 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML02_COPYRIGH from '@/components/xhtml/02_Copyrigh'
 import XHTML01_TITLE_PA from '@/components/xhtml/01_Title_Pa'
 import XHTML03_DEDICATI from '@/components/xhtml/03_Dedicati'
 import XHTML04_CONTENTS from '@/components/xhtml/04_Contents'
 import XHTML05_FOREWORD from '@/components/xhtml/05_Foreword'
 import XHTML06_PREFACEW from '@/components/xhtml/06_PrefaceW'
 import XHTML07_ACKNOWLE from '@/components/xhtml/07_Acknowle'
 import XHTML08_PART_ONE from '@/components/xhtml/08_Part_One'
 import XHTML09_1_THE_IN from '@/components/xhtml/09_1_The_In'
 import XHTML10_2_VENTUR from '@/components/xhtml/10_2_Ventur'
 import XHTML11_3_ECOCID from '@/components/xhtml/11_3_Ecocid'
 import XHTML12_4_TALKIN from '@/components/xhtml/12_4_Talkin'
 import XHTML13_5_CONSER from '@/components/xhtml/13_5_Conser'
 import XHTML14_PART_TWO from '@/components/xhtml/14_Part_Two'
 import XHTML15_6_WHY_WE from '@/components/xhtml/15_6_Why_We'
 import XHTML16_7_CAUTIO from '@/components/xhtml/16_7_Cautio'
 import XHTML17_8_COYOTE from '@/components/xhtml/17_8_Coyote'
 import XHTML18_9_WHY_EV from '@/components/xhtml/18_9_Why_Ev'
 import XHTML19_10_REINT from '@/components/xhtml/19_10_Reint'
 import XHTML20_11_PRZEW from '@/components/xhtml/20_11_Przew'
 import XHTML21_12_WHY_I from '@/components/xhtml/21_12_Why_I'
 import XHTML22_PART_THR from '@/components/xhtml/22_Part_Thr'
 import XHTML23_13_THE_I from '@/components/xhtml/23_13_The_I'
 import XHTML24_14_CONSE from '@/components/xhtml/24_14_Conse'
 import XHTML25_PART_FOU from '@/components/xhtml/25_Part_Fou'
 import XHTML26_15_ANTHR from '@/components/xhtml/26_15_Anthr'
 import XHTML27_16_NATUR from '@/components/xhtml/27_16_Natur'
 import XHTML28_17_CONSE from '@/components/xhtml/28_17_Conse'
 import XHTML29_18_THE_W from '@/components/xhtml/29_18_The_W'
 import XHTML30_19_CONSU from '@/components/xhtml/30_19_Consu'
 import XHTML31_20_CHILD from '@/components/xhtml/31_20_Child'
 import XHTML32_PART_FIV from '@/components/xhtml/32_Part_Fiv'
 import XHTML33_21_COMPA from '@/components/xhtml/33_21_Compa'
 import XHTML34_22_EXPLA from '@/components/xhtml/34_22_Expla'
 import XHTML35_23_A_TRI from '@/components/xhtml/35_23_A_Tri'
 import XHTML36_24_CONSE from '@/components/xhtml/36_24_Conse'
 import XHTML37_25_IS_GR from '@/components/xhtml/37_25_Is_Gr'
 import XHTML38_26_AVATA from '@/components/xhtml/38_26_Avata'
 import XHTML39_SOME_CLO from '@/components/xhtml/39_Some_Clo'
 import XHTML40_ABOUT_TH from '@/components/xhtml/40_About_th'
 import XHTML41_CONTRIBU from '@/components/xhtml/41_Contribu'
 import XHTML42_INDEX from '@/components/xhtml/42_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/04_Contents",
 			"name" : "xhtml/04_Contents",
 			"component" : XHTML04_CONTENTS
 		},
 		{
 			"path" : "/xhtml/05_Foreword",
 			"name" : "xhtml/05_Foreword",
 			"component" : XHTML05_FOREWORD
 		},
 		{
 			"path" : "/xhtml/06_PrefaceW",
 			"name" : "xhtml/06_PrefaceW",
 			"component" : XHTML06_PREFACEW
 		},
 		{
 			"path" : "/xhtml/07_Acknowle",
 			"name" : "xhtml/07_Acknowle",
 			"component" : XHTML07_ACKNOWLE
 		},
 		{
 			"path" : "/xhtml/08_Part_One",
 			"name" : "xhtml/08_Part_One",
 			"component" : XHTML08_PART_ONE
 		},
 		{
 			"path" : "/xhtml/09_1_The_In",
 			"name" : "xhtml/09_1_The_In",
 			"component" : XHTML09_1_THE_IN
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js